/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".figure-caption[_ngcontent-%COMP%] {\n  font-size: 21pt;\n  color: black; }\n\nfieldset.scheduler-border[_ngcontent-%COMP%] {\n  border: solid 1.3pt black;\n  padding: 0 13.3pt 13.3pt 13.3pt; }\n\nlegend.scheduler-border[_ngcontent-%COMP%] {\n  width: auto;\n  font-size: 10.6pt; }"];
export { styles as styles };
